<template>
  <div>
    <div class="white black--text"  v-if="fulfillmentData">
      <app-alert @dismissed="onDismissed"  v-if="error" :text="error.message"></app-alert>

      <v-tabs
          v-model="tab"
          centered
          background-color="pink lighten-5"
          color="white"
      >
        <v-tabs-slider color="pink"></v-tabs-slider>

        <v-tab
            v-for="item in tabItems"
            :key="item"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <!--      status tab-->
        <v-tab-item>
          <v-card flat>
            <v-card-title v-if="hourlyRate">Client Clock</v-card-title>
            <v-card-text v-if="fulfillmentData.orderData.clientInfo">
              <div class="subtitle-1 mb-6 " v-if="fulfillmentData.orderData.clientInfo">{{fulfillmentData.orderData.clientInfo.name}}</div>
              <a v-for="location in fulfillmentData.orderData.locations" :key="location.created" style="text-decoration:none" class="blue--text" target="_blank"
                 :href="'https://www.google.com/maps/place/' + location.formatted_address">
                <div><v-icon class="red--text">location_pin</v-icon> {{location.name}}</div>
              </a>
              <v-btn class="blue--text" outlined @click="openEta">Text ETA</v-btn>
            </v-card-text>

            <!--            client time sheet-->
            <multi-clock-tracker
                v-if="fulfillmentData"
                @clientNotification="clientTrackerNotification"
                :type="'clientTimesheet'" :fulfillmentData="fulfillmentData">
            </multi-clock-tracker>


            <v-card-text v-if="hourlyRate">
              <div class="subtitle-1" v-if="fulfillmentData.clientCheckIn">Start: {{momentTime(fulfillmentData.clientCheckIn)}}</div>
              <div class="subtitle-1" v-if="fulfillmentData.clientCheckIn && !fulfillmentData.clientCheckOut">Duration: {{clientDuration}} Hrs</div>
              <div class="subtitle-1" v-if="fulfillmentData.clientCheckOut">End: {{momentTime(fulfillmentData.clientCheckOut)}}</div>
              <div class="subtitle-1 font-weight-bold" v-if="fulfillmentData.clientCheckIn && fulfillmentData.clientCheckOut">Total time: {{totalClientTime}} Hrs</div>



              <v-btn v-if="!fulfillmentData.clientCheckIn" class="pink--text" outlined block
                     @click="initClientClock">
                <v-icon>timer</v-icon>
                clock in
              </v-btn>
              <v-btn v-if="fulfillmentData.clientCheckIn && !fulfillmentData.clientCheckOut"
                     class="pink--text" outlined block dark
                     @click="initClientClockOut">clock out</v-btn>
            </v-card-text>

            <v-switch
                color="blue"
                v-model="hourlyRate"
                label="Hourly rate contract"
            ></v-switch>
            <v-card-actions>
              <v-btn v-if="fulfillmentData.orderData.clientInfo"
                     @click="textClient"
                     class="blue--text"
                     outlined
              >
                Text {{fulfillmentData.orderData.clientInfo.name}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
<!--        contacts-->
        <v-tab-item>
          <v-card>
            <v-card-title>Active Crew</v-card-title>
            <v-list-item
                @click="openContact(contact)"
                v-for="contact in fulfillmentData.activeContacts"
                :key="contact.phoneNumber"
            >
              <v-list-item-title>{{contact.name}}</v-list-item-title>
              <!--                <v-list-item-icon @click="removeContractor(contact)">-->
              <!--                  <v-icon class="warning&#45;&#45;text">close</v-icon>-->
              <!--                </v-list-item-icon>-->
            </v-list-item>
            <v-card-title>Crew Clock</v-card-title>
            <!--            client time sheet-->
            <multi-clock-tracker
                v-if="fulfillmentData"
                @crewNotification="notifyCrew"
                :type="'crewTimesheet'" :fulfillmentData="fulfillmentData">
            </multi-clock-tracker>
            <v-card-text>
              <div class="subtitle-1" v-if="fulfillmentData.startTime">Start: {{momentTime(fulfillmentData.startTime)}}</div>
              <div class="subtitle-1" v-if="fulfillmentData.startTime && !fulfillmentData.endTime">Duration: {{durationNow}} Hrs</div>
              <div class="subtitle-1" v-if="fulfillmentData.endTime">End: {{momentTime(fulfillmentData.endTime)}}</div>
              <div class="subtitle-1 font-weight-bold" v-if="fulfillmentData.startTime && fulfillmentData.endTime">Total time: {{totalTime}} Hrs</div>
              <v-btn v-if="!fulfillmentData.startTime" class="pink--text" outlined block  @click="initServiceClock">
                <v-icon>timer</v-icon>
                clock in
              </v-btn>
              <v-btn v-if="fulfillmentData.startTime && !fulfillmentData.endTime"
                     class="pink--text" outlined block dark
                     @click="initServiceClockOut">
                clock out</v-btn>
              <v-btn v-if="fulfillmentData.startTime && fulfillmentData.endTime"
                     class="blue--text" outlined block dark
                     @click="textPayoutDetails">
                Text Payout</v-btn>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="fulfillmentData"
                     @click="textContacts"
                     class="blue--text"
                     outlined
              >
                Text Contcats
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
<!--        billing-->
        <v-tab-item v-if="fulfillmentData.orderData">
        <v-card>
          <v-card-title>
            Update Invoice
          </v-card-title>
          <v-card-text>
            <v-simple-table
                fixed-header
                class="elevation-1"
            >
              <template >
                <thead>
                <tr>
                  <th class="text-left">
                    Name
                  </th>
                  <th>
                    Qty
                  </th>
                  <th>
                    Rate/Price ($)
                  </th>
                  <th class="text-right">
                    Total ($)
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="items">
                  <td v-if="items.length === 0">
                    <v-icon>add</v-icon>
                  </td>
                  <td v-if="items.length === 0">
                    Add line items or transfer from timesheet.
                  </td>
                </tr>
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                    @click="editItem(item)"
                >
                  <td>{{ item.title }}</td>
                  <td>{{ item.qty }}</td>
                  <td>{{ item.unitPrice }}</td>
                  <td class="text-right">
                    {{Number(item.qty * item.unitPrice).toFixed(2)}}
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <!--            total-->
          <v-card-actions>
            <!--                    <v-btn @click="updateOrder" icon><v-icon class="primary&#45;&#45;text">autorenew</v-icon></v-btn>-->
            <!--                    <v-spacer></v-spacer>-->
            <v-btn text> Qty: {{totalQuantity }}</v-btn>
            <v-btn text> Invoice Total: ${{totalCost}}</v-btn>
          </v-card-actions>
          <v-card-actions>

<!--            transfer line items to invoice-->

<!--            <v-btn @click="pushItemsToInvoice" v-if="totalQuantity > 0" outlined class="green&#45;&#45;text" color="green">-->
<!--              <v-icon></v-icon>-->
<!--              Add items to invoice</v-btn>-->
          </v-card-actions>
          <v-card-actions>
            <v-btn @click="addNewItem" outlined block>Add new item</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn @click="timesheetTransferDialog = true" outlined block>Transfer from Timesheet</v-btn>
          </v-card-actions>
        </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-btn v-if="fulfillmentData.endTime" class="mt-4 pink white--text" block>Fulfilled</v-btn>
    </div>
    <v-dialog v-model="clockInDialog"
        persistent
        max-width="300"
    >
      <v-card v-if="fulfillmentData">
        <v-card-title class="text-h5">
          Start Clock
        </v-card-title>
<!--        service contacts-->
        <v-card-text v-if="!setClientClock">
          <v-list-item
              v-for="contact in fulfillmentData.activeContacts"
              :key="contact.phoneNumber"
          >
            <v-list-item-title>{{contact.name}}</v-list-item-title>
            <!--                <v-list-item-icon @click="removeContractor(contact)">-->
            <!--                  <v-icon class="warning&#45;&#45;text">close</v-icon>-->
            <!--                </v-list-item-icon>-->
          </v-list-item>
        </v-card-text>
<!--        client contact-->
        <v-card-text v-else>
          <v-list-item>
            <v-list-item-title>{{fulfillmentData.orderData.clientInfo.name}}</v-list-item-title>
            <!--                <v-list-item-icon @click="removeContractor(contact)">-->
            <!--                  <v-icon class="warning&#45;&#45;text">close</v-icon>-->
            <!--                </v-list-item-icon>-->
          </v-list-item>
        </v-card-text>
        <v-card-text>
          <v-textarea v-model="notificationMsg" outlined label="Text message"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="clockInDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="startServiceClock"
              v-if="!setClientClock"
          >
            Start Service Clock
          </v-btn>
          <v-btn
              v-else
              color="green darken-1"
              text
              @click="startClientClock"
          >
            Start Client Clock
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="clockOutDialog"
        persistent
        max-width="300"
    >
      <v-card v-if="fulfillmentData">
        <v-card-title class="text-h5">
          End Clock
        </v-card-title>
<!--        service contact-->
        <v-card-text v-if="!setClientClock">
          <v-list-item
              v-for="contact in fulfillmentData.activeContacts"
              :key="contact.phoneNumber"
          >
            <v-list-item-title>{{contact.name}}</v-list-item-title>
            <!--                <v-list-item-icon @click="removeContractor(contact)">-->
            <!--                  <v-icon class="warning&#45;&#45;text">close</v-icon>-->
            <!--                </v-list-item-icon>-->
          </v-list-item>
        </v-card-text>
<!--        client contact-->
        <v-card-text v-else>
          <v-list-item>
            <v-list-item-title>{{fulfillmentData.orderData.clientInfo.name}}</v-list-item-title>
            <!--                <v-list-item-icon @click="removeContractor(contact)">-->
            <!--                  <v-icon class="warning&#45;&#45;text">close</v-icon>-->
            <!--                </v-list-item-icon>-->
          </v-list-item>
        </v-card-text>
        <v-card-text>
          <v-textarea v-model="notificationMsg" outlined label="Text message"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="clockOutDialog = false"
          >
            cancel
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              v-if="!setClientClock"
              @click="endClock"
          >
            End Service Clock
          </v-btn>
          <v-btn
              v-else
              color="green darken-1"
              text
              @click="endClientClock"
          >
            End Client Clock
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editItemDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedItem.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.title" label="Name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.qty" type="number" label="Quantity"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.unitCost" type="number" label="Unit Cost"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.unitPrice" type="number" label="Sale Price"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.note" label="Note"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.instruction" label="Instruction"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn small text @click="deleteItem(editedItem)">
            <v-icon  >mdi-delete
            </v-icon>
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="notificationDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ notificationDialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
              v-if="initEta"
              prepend-icon="timer"
              type="number"
              label="Estimated arrival"
              append-icon="refresh"
              v-model="eta"
          ></v-text-field>
          <v-text-field
              v-if="calcPayout"
              prepend-icon="attach_money"
              type="number"
              label="Rate per hour"
              append-icon="refresh"
              @click:append="textPayoutDetails"
              v-model="contractHourlyRate"
          ></v-text-field>
          <v-textarea
              clearable
            label="Message"
            placeholder="message body ..."
            v-model="notificationMsg"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeNotificationMsg">cancel</v-btn>
          <v-btn class="blue" dark @click="sendText"><v-icon>send</v-icon>Send Text</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="timesheetTransferDialog" persistent max-width="500px">
      <v-card v-if="fulfillmentData">
        <v-card-title>
          <span class="headline">Select and transfer</span>
        </v-card-title>
        <v-card-text v-if="fulfillmentData.clientTimesheet">
          <!--            if not clocked in or out show current time-->
          <v-list v-for="item in fulfillmentData.clientTimesheet" :key="item.id">
            <v-list-item v-if="item.clockedOut">
              <v-list-item-action>
                <v-checkbox
                    v-model="item.selected"
                    color="blue"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-title>
                <h2 class="subtitle-1">
                  {{ item.name }}
                </h2>
              </v-list-item-title>
              <v-text-field
                  prepend-icon="price"
                  type="number"
                  label="Rate/price"
                  v-model="item.unitPrice"
              ></v-text-field>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="timesheetTransferDialog = false">cancel</v-btn>
          <v-btn class="green" dark @click="transferFromTimesheet"><v-icon>check</v-icon>Transfer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import {addDoc, collection, doc, onSnapshot, updateDoc} from "firebase/firestore";
import {v1 as uuidv1} from "uuid";
export default {
  props: ["id"],
  data () {
    return {
      tab: null,
      tabItems: [
        'status', 'contacts', 'billing & Payout'
      ],
      fulfillmentData: undefined,
      textMessage: 'Auto generated text',
      clockInDialog: false,
      clockOutDialog: false,
      setClientClock: false,
      hourlyRate: false,
      items: null,
      totalCost: 0,
      totalQuantity: 0,
      totalProfit: 0,
      editedIndex: -1,
      editedItem: {
        qty: 0,
        unitPrice: 0,
        unitCost: 0,
        title: '',
        note: '',
        instruction: ''
      },
      editItemDialog: false,
      balanceRemaining: 0,
      timesheetTransferDialog: false,
      notificationMsg: null,
      notificationDialog: false,
      notificationDialogTitle: '',
      smsClient: false,
      smsContacts: false,
      calcPayout: false,
      contractHourlyRate: 20,
      initEta: false,
      eta: 30
    }
  },
  watch: {
    hourlyRate (value) {
      this.fulfillmentData.hourlyRate = value
      this.updateFulfillment()
    },
    eta (value) {
      this.notificationMsg = "Hi " + this.fulfillmentData.orderData.clientInfo.name
          + ". we should be there in " + value + " minutes"
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do')
        return day
      }
    },
    momentTime () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do hh:mm A')
        return day
      }
    },
    clockInOutTime () {
      return (date) => {
        let day = moment(date).format('hh:mm A ddd, MMM Do')
        return day
      }
    },
    user () {
      return this.$store.getters.user
    },
    durationNow () {
      if (this.fulfillmentData) {
        if (this.fulfillmentData.startTime) {
          let end = Date.now()
          // console.log(this.fulfillmentData.startTime)
          let duration = moment.duration(end - this.fulfillmentData.startTime)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        } else return 0
      } else return 0
    },
    clientDuration () {
      if (this.fulfillmentData) {
        if (this.fulfillmentData.clientCheckIn) {
          let end = Date.now()
          // console.log(this.fulfillmentData.startTime)
          let duration = moment.duration(end - this.fulfillmentData.clientCheckIn)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        } else return 0
      } else return 0
    },
    totalTime () {
      if (this.fulfillmentData) {
        // console.log(this.fulfillmentData)
        if (this.fulfillmentData.endTime) {
          let end = this.fulfillmentData.endTime
          // console.log(this.fulfillmentData.endTime)
          let duration = moment.duration(end - this.fulfillmentData.startTime)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        } else {
          let end = Date.now()
          let duration = moment.duration(end - this.fulfillmentData.startTime)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        }
      } else return 0
    },
    totalClientTime () {
      if (this.fulfillmentData) {
        // console.log(this.fulfillmentData)
        if (this.fulfillmentData.clientCheckOut) {
          let end = this.fulfillmentData.clientCheckOut
          // console.log(this.fulfillmentData.endTime)
          let duration = moment.duration(end - this.fulfillmentData.clientCheckIn)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        } else {
          let end = Date.now()
          let duration = moment.duration(end - this.fulfillmentData.clientCheckIn)
          let hours = duration.asHours()
          return Number(hours).toFixed(2)
        }
      } else return 0
    },
    totalDue () {
      if (this.fulfillmentData) {
        // console.log(this.fulfillmentData)
        if (this.fulfillmentData.clientCheckOut) {
          return Number(this.contractHourlyRate * this.totalTime).toFixed(2)
        } else {
          return 0
        }
      } else return 0
    }
  },
  created() {
    let db = this.$store.state.db
    let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', this.id)
    onSnapshot(fulfillmentRef, res => {
      if (res.exists) {
        let data = res.data()
        this.fulfillmentData = data
        if (data.orderData.items) {
          this.items = data.orderData.items
          // console.log(this.items)
          this.calcTotals(this.items)
        } else this.items = []
        if (data.hourlyRate) {
          this.hourlyRate = true
        }
      }
    })
  },
  methods: {
    // pushItemsToInvoice () {
    //   let db = this.$store.state.db
    //   let orderRef = doc(db, 'users', this.user.uid + '/orders/' + this.id)
    //   let orderData = this.fulfillmentData.orderData
    //   orderData.status = 'warning'
    //   console.log(orderData)
    //   this.items.forEach(item => {
    //     orderData.lineItems.push(item)
    //   })
    //   this.timesheetTransferDialog = false
    //   // console.log(this.orderData)
    //   updateDoc(orderRef, orderData)
    //       .catch(err => {
    //         this.$store.dispatch('setError', err)
    //       })
    //
    // },
    transferFromTimesheet () {
      let timesheets = this.fulfillmentData.clientTimesheet
      timesheets.forEach(item => {
        if (item.selected) {
          let newItem = {title: item.name}
          newItem.unitPrice = item.unitPrice
          newItem.unitCost = 0
          newItem.id = uuidv1()
          newItem.qty = Number(this.totalDuration(item))
          // console.log(newItem)
          return this.itemSelected(newItem)
        }
      })
      this.timesheetTransferDialog = false
    },
    convertToTimestamp(entry) {
      const dateTimeString = `${entry.date} ${entry.time}`; // "2025-02-23 12:00"
      return new Date(dateTimeString).getTime(); // Convert to Unix timestamp
    },
    totalDuration(recordedTimestamps) {
      let clockedIn = this.convertToTimestamp(recordedTimestamps.clockedIn)
      let clockedOut = this.convertToTimestamp(recordedTimestamps.clockedOut)
      let diffInSeconds = Math.floor((clockedOut - clockedIn) / 1000);

      return Number(diffInSeconds/3600).toFixed(2)
    },
    addNewItem () {
      let newItem = {title: 'Item'}
      newItem.unitPrice = 0
      newItem.unitCost = 0
      newItem.note = ''
      newItem.instruction = ''
      newItem.id = uuidv1()
      newItem.qty = 1
      return this.itemSelected(newItem)
    },
    clientTrackerNotification (obj) {
      console.log(obj)
      this.notificationMsg = obj
      this.textClient ()

    },
    closeNotificationMsg () {
      this.notificationDialog = false
      this.notificationDialogTitle = ''
      this.notificationMsg = ''
      this.calcPayout = false
      this.smsClient = false
      this.initEta = false
    },
    openEta () {
      let cord
      this.$getLocation()
          .then(coordinates => {
            cord = coordinates
            //console.log(cord)
            this.getPickUpAddress = "latlng=" + cord.lat + "," + cord.lng
          })
          .then(() => {
            let gmapPlacesApi = 'https://maps.googleapis.com/maps/api/geocode/json?'
            //flex pickup api
            let apiKey = "AIzaSyCkoOOpVIU1NrXnBrB_uDZl6f_ybcdytl0"
            let params = '&key=' + apiKey
            let placeSearch = gmapPlacesApi + this.getPickUpAddress + params
            return this.axios.get(placeSearch)
          })
          .then((response) => {
            this.searchPickupSpinner = false
            this.approxLocation = response.data.results[0]
            this.getPickUpAddress = ''
            this.fulfillmentData.lastActiveLocation = this.approxLocation
            if(!this.fulfillmentData.locationHistory) {
              this.fulfillmentData.locationHistory = [{...this.approxLocation, created: Date.now()}]
            } else {
              this.fulfillmentData.locationHistory.push({...this.approxLocation, created: Date.now()})
            }
            //console.log(this.fulfillmentData)
            this.notificationDialog = true
            this.initEta = true
            this.notificationDialogTitle = 'Text ETA'
            this.notificationMsg = "Hi " + this.fulfillmentData.orderData.clientInfo.name
                + ". we should be there in " + this.eta + " minutes"
            this.$store.dispatch('setLoading', false)
          })
          .catch(err => {
            this.$store.dispatch('setLoading', false)
            console.log(err)
          })
    },
    textPayoutDetails () {
      this.notificationDialogTitle = "Payout"
      this.calcPayout = true
      this.notificationMsg = 'Sending $' + this.totalDue + " for " + this.totalTime + ' hours.'
     // console.log(this.notificationMsg)
      this.notificationDialog = true
      this.smsContacts = true
      // notifyContacts (msg)
      },
    openContact (contact) {
      console.log(contact)
    },
    textClient () {
      this.notificationDialogTitle = "Text " + this.fulfillmentData.orderData.clientInfo.name
      this.notificationDialog = true
      this.smsClient = true
    },
    textContacts () {
      this.notificationDialogTitle = "Text Contacts"
      this.notificationDialog = true
      this.smsContacts = true
    },
    sendText () {
      this.notificationDialog = false
      if (this.smsClient) {
        this.notifyClient (this.notificationMsg)
      }
      if (this.smsContacts) {
        this.notifyContacts(this.notificationMsg)
      }
      if (this.initEta) {
        this.notifyClient (this.notificationMsg)
      }
      this.closeNotificationMsg ()
    },
    close () {
      this.editItemDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        //console.log(this.editedItem)
        this.editedItem.totalPrice = this.editedItem.qty * this.editedItem.unitPrice
        Object.assign(this.items[this.editedIndex], this.editedItem)
        //console.log(this.items)
      }
      this.calcTotals (this.items)
      this.updateFulfillment()
      this.close()
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      // console.log(item)
      this.editedItem = Object.assign({}, item)
      this.editItemDialog = true
    },
    deleteItem (item) {
      let deleteItem = this.items.find(i => {
        return i.id === item.id
      })
      const index = this.items.indexOf(deleteItem)
      this.items.splice(index, 1)
      this.editItemDialog = false
      // console.log(this.items)
      // console.log(item)
      this.updateFulfillment()
    },
    calcTotals (value) {
      if(value.length !== 0) {
        let totalQty = 0
        let totalCost = 0
        let totalProfit = 0
        let totalBuyingCost = 0
        for(let i in value){
          // console.log(value)
          totalQty += Number(value[i].qty)
          totalCost += Number(value[i].unitPrice) * Number(value[i].qty)
          totalBuyingCost += Number(value[i].unitCost) * Number(value[i].qty)
        }
        // console.log(totalCost)
        totalProfit = totalCost - totalBuyingCost
        this.totalCost = totalCost
        this.totalQuantity = totalQty
        this.totalProfit = totalProfit
      }
    },
    itemSelected (value) {
      let item = value
      // console.log(item)
      item.totalPrice = item.unitPrice * item.qty
      this.items.push(item)
      this.calcTotals(this.items)
      this.updateFulfillment()
    },
    initClientClock () {
      this.notificationMsg = 'Just got here. Checked in at ' + this.clockInOutTime(Date.now())
      this.setClientClock = true
      this.clockInDialog = true
    },
    initClientClockOut () {
      this.notificationMsg = 'Clocked out at ' + this.clockInOutTime(Date.now())
          + '. Total time: ' + this.totalClientTime + ' Hrs.'
      this.setClientClock = true
      this.clockOutDialog = true
    },
    startClientClock () {
      let timeStamp = Date.now()
      this.fulfillmentData.clientCheckIn = timeStamp
      this.clockInDialog = false
      this.updateFulfillment()
      this.notifyClient(this.notificationMsg)
    },
    endClientClock () {
      this.clockOutDialog = false
      let timeStamp = Date.now()
      this.fulfillmentData.clientCheckOut = timeStamp
      this.updateFulfillment()
      //console.log(this.fulfillmentData)
      this.notifyClient(this.notificationMsg)
    },
    initServiceClockOut () {
      this.setClientClock = false
      this.notificationMsg = 'Clocked out at ' + this.clockInOutTime(Date.now()) + '. Total time: ' + this.totalTime + ' Hrs.'
      this.clockOutDialog = true
    },
    initServiceClock () {
      this.setClientClock = false
      this.notificationMsg = 'Clocked in at ' + this.clockInOutTime(Date.now())
      this.clockInDialog = true
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    startServiceClock () {
      let timeStamp = Date.now()
      this.fulfillmentData.startTime = timeStamp
      this.clockInDialog = false
      this.updateFulfillment()
      this.notifyContacts(this.notificationMsg)
    },
    endClock () {
      this.clockOutDialog = false
      let timeStamp = Date.now()
      this.fulfillmentData.endTime = timeStamp
      this.updateFulfillment()
      //console.log(this.fulfillmentData)
      this.notifyContacts(this.notificationMsg)
    },
    notifyContacts (msg) {
      //console.log(msg)
      let id = uuidv1()
      let users = this.fulfillmentData.activeContacts
      let msgObj = {
        text: msg,
        created: Date.now(),
        id: id,
        direction: 'outgoing'
      }
      let db = this.$store.state.db
      for(let key in users) {
        let time = Date.now()
        let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/'+ users[key].connectedPhoneNumber + '/sms/'+ users[key].phoneNumber)
        let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + users[key].connectedPhoneNumber + '/sms/' + users[key].phoneNumber + '/messages')
        // console.log(users[key])
        updateDoc(userSMSRef,{
          lastActive: time,
          lastMessage: msgObj.text
        })
            .then(()=> {
              let outgoingMsg = {...msgObj}
              outgoingMsg.created = time
              if (this.mediaUrl) {
                outgoingMsg.mediaUrl = this.mediaUrl
                // if (this.textMessage !== '') {
                //   outgoingMsg.text = ' '
                // }
              }
              return addDoc(userMsgsRef, outgoingMsg)
            })
            // .then(() => {
            //   updateDoc(segmentContactRef, {lastActive: time, lastMessage: msgObj.text})
            // })
            .catch(err => {
              this.$store.dispatch('setError', err)
              console.log(err)
            })
      }
    },
    notifyClient (msg) {
      //console.log(msg)
      let id = uuidv1()
      let user = this.fulfillmentData.orderData.clientInfo
      let msgObj = {
        text: msg,
        created: Date.now(),
        id: id,
        direction: 'outgoing'
      }
      //console.log(this.fulfillmentData.orderData.clientInfo)
      let db = this.$store.state.db
      let time = Date.now()
      let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/'+ user.connectedPhoneNumber + '/sms/'+ user.phoneNumber)
      let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + user.connectedPhoneNumber + '/sms/' + user.phoneNumber + '/messages')
      updateDoc(userSMSRef,{
        lastActive: time,
        lastMessage: msgObj.text
      })
          .then(()=> {
            let outgoingMsg = {...msgObj}
            outgoingMsg.created = time
            if (this.mediaUrl) {
              outgoingMsg.mediaUrl = this.mediaUrl
              // if (this.textMessage !== '') {
              //   outgoingMsg.text = ' '
              // }
            }
            return addDoc(userMsgsRef, outgoingMsg)
          })
          // .then(() => {
          //   updateDoc(segmentContactRef, {lastActive: time, lastMessage: msgObj.text})
          // })
          .catch(err => {
            this.$store.dispatch('setError', err)
            console.log(err)
          })
    },
    notifyCrew (obj) {
      //console.log(msg)
      let id = uuidv1()
      let users = obj.notifyCrew
      let msgObj = {
        text: obj.text,
        created: Date.now(),
        id: id,
        direction: 'outgoing'
      }
      let db = this.$store.state.db
      for(let key in users) {
        let time = Date.now()
        let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/'+ users[key].connectedPhoneNumber + '/sms/'+ users[key].phoneNumber)
        let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + users[key].connectedPhoneNumber + '/sms/' + users[key].phoneNumber + '/messages')
        // console.log(users[key])
        updateDoc(userSMSRef,{
          lastActive: time,
          lastMessage: msgObj.text
        })
            .then(()=> {
              let outgoingMsg = {...msgObj}
              outgoingMsg.created = time
              if (this.mediaUrl) {
                outgoingMsg.mediaUrl = this.mediaUrl
                // if (this.textMessage !== '') {
                //   outgoingMsg.text = ' '
                // }
              }
              return addDoc(userMsgsRef, outgoingMsg)
            })
            // .then(() => {
            //   updateDoc(segmentContactRef, {lastActive: time, lastMessage: msgObj.text})
            // })
            .catch(err => {
              this.$store.dispatch('setError', err)
              console.log(err)
            })
      }
    },
    updateFulfillment() {
      let db = this.$store.state.db
      this.fulfillmentData.orderData.items = this.items
      let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', this.id)
      updateDoc(fulfillmentRef, this.fulfillmentData)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
  }
}
</script>
